import { memo } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

// Linked with src\business\edd-state.utils.ts in Bitbang
export enum OlkyPassCustomerStatus {
  VALIDATED = "Validated",
  ONGOING = "Ongoing",
  INACTIVE = "Inactive"
}
//

type OlkyPassCustomerStatusLabelProps = {
  state: OlkyPassCustomerStatus;
  className?: string;
};

export const OlkyPassCustomerStatusLabel = memo(
  (props: OlkyPassCustomerStatusLabelProps) => {
    const { state, className } = props;
    const { t } = useTranslation(["atoms"]);
    let style: string = "border-2 rounded-sm px-2 py-1 text-sm lg:text-base";
    let message: string = "";

    switch (state) {
      case OlkyPassCustomerStatus.VALIDATED:
        style = twMerge(style, "border-success-600 bg-success-50 text-success-600");
        message = t("molecules.edd_state_label.validated");
        break;
      case OlkyPassCustomerStatus.ONGOING:
        style = twMerge(style, "border-porange-500 bg-porange-50 text-porange-500");
        message = t("molecules.edd_state_label.ongoing");
        break;
      case OlkyPassCustomerStatus.INACTIVE:
        style = twMerge(style, "border-grey-500 bg-grey-50 text-grey-500");
        message = t("molecules.edd_state_label.inactive");
    }

    return <div className={twMerge(style, className)}>{message}</div>;
  },
  (
    prevProps: Readonly<OlkyPassCustomerStatusLabelProps>,
    nextProps: Readonly<OlkyPassCustomerStatusLabelProps>
  ) => {
    const isStateSame = prevProps.state === nextProps.state;
    const isStyleSame = prevProps.className === nextProps.className;
    return isStateSame && isStyleSame;
  }
);
